module.exports = __webpack_public_path__ + "static/media/METAHERO.b7e4cdd8.svg";